export default __webpack_public_path__ + "static/media/vue.c286d2da.svg";